import { Routes, Route, Navigate } from 'react-router-dom';
import Login from '../pages/Login';
import Dashboard from '../pages/Dashboard';
import Etiketler from '../pages/Etiketler';
import EtiketEkle from '../pages/Etiketler/create';
import Formlar from '../pages/Formlar';
import Reklamlar from '../pages/Reklamlar';
import Profil from '../pages/Profil';
import SifreDegistir from '../pages/SifreDegistir';
import FormDetay from '../pages/FormDetay';
import Logout from '../pages/Logout';
import ProtectedRoute from '../components/ProtectedRoute';
import AdminRoute from '../components/AdminRoute';
import Reports from '../pages/Reports';
import CustomerCreate from '../pages/Customer/create';
import HedefKitle from '../pages/HedefKitle';
import GoogleAds from '../pages/GoogleAds';
import Sozlesme from '../pages/Sozlesme';
import Ayarlar from '../pages/Ayarlar';
import Temsilciler from '../pages/Temsilciler';

const AppRoutes = () => (
    <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/labels" element={<ProtectedRoute><Etiketler /></ProtectedRoute>} />
        <Route path="/create-label" element={<ProtectedRoute><EtiketEkle /></ProtectedRoute>} />
        <Route path="/forms" element={<ProtectedRoute><Formlar /></ProtectedRoute>} />
        <Route path="/reports" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
        <Route path="/create-customer" element={<ProtectedRoute><CustomerCreate /></ProtectedRoute>} />
        <Route path="/lead-detail" element={<ProtectedRoute><FormDetay /></ProtectedRoute>} />
        <Route path="/google-ads" element={<ProtectedRoute><GoogleAds /></ProtectedRoute>} />
        <Route path="/ads" element={<ProtectedRoute><Reklamlar /></ProtectedRoute>} />
        <Route path="/targeting-suggestion" element={<ProtectedRoute><HedefKitle /></ProtectedRoute>} />
        <Route path="/my-account" element={<ProtectedRoute><Profil /></ProtectedRoute>} />
        <Route path="/change-password" element={<ProtectedRoute><SifreDegistir /></ProtectedRoute>} />
        <Route path="/contract" element={<ProtectedRoute><Sozlesme /></ProtectedRoute>} />
        <Route path="/settings" element={<ProtectedRoute><Ayarlar /></ProtectedRoute>} />
        <Route path="/temsilciler" element={<AdminRoute><Temsilciler /></AdminRoute>} />
        <Route path="*" element={<Navigate to="/login" />} />
    </Routes>
);

export default AppRoutes;
